import { TabData } from '../types';

export const PLUG_AND_PLAY_TABS: TabData[] = [
  {
    id: 'individuals',
    title: 'Individuals',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1605873928_individuals.svg',
    image:
      'https://assets1.cleartax-cdn.com/cleartax/images/1607343696_fileitr.png',
    products: [
      {
        id: 'self-itr',
        label: 'SelfITR',
        title: 'Self ITR Filing',
        description: 'File tax returns in under 3 minutes',
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1603968068_ic_itr.svg',
        link: 'https://cleartax.in/filing?utm_ref=itr_2025_organic_homepage',
        image:
          'https://assets1.cleartax-cdn.com/cleartax/images/1607343696_fileitr.png',
      },
      {
        id: 'luxury-support',
        label: 'LuxurySupport',
        title: 'Luxury Tax Support',
        description: 'Get a personal tax expert for tailored tax strategy',
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1606217684_clearservices.svg',
        link: 'https://cleartax.in/s/pricing?utm_ref=itr_2025_organic_homepage',
        image:
          'https://assets.clear.in/cleartax/images/1752218967_image217.png',
      },
      {
        id: 'assisted-filing',
        label: 'AssistedFiling',
        title: 'Assisted filing',
        description: 'Get experts for filing taxes and starting up',
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1606217655_clearinvest.svg',
        link: 'https://cleartax.in/s/pricing?utm_ref=itr_2025_organic_homepage',
        image:
          'https://assets.clear.in/cleartax/images/1752218800_frame1814221062.png',
      },
      {
        id: 'black-app',
        label: 'Black App',
        title: 'Black',
        description: 'More money in your pocket with Black app',
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1603967633_ic_black_app.svg',
        link: 'https://cleartax.in/s/black?utm_ref=itr_2025_organic_homepage',
        badge: 'app',
        image:
          'https://assets1.cleartax-cdn.com/cleartax/images/1605864579_desktop_fold_plugandplay_individuals_blackapp.png',
      },
    ],
  },
  {
    id: 'enterprise',
    title: 'Enterprise',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1605874053_enterprise.svg',
    image:
      'https://assets1.cleartax-cdn.com/cleartax/images/1605871021_desktop_fold_plugandplay_enterprise_cleareinvoicing.png',
    products: [
      {
        id: 'clear-einvoicing',
        label: 'Clear e-Invoicing',
        title: 'Clear e-Invoicing',
        description: 'Fast, dependable and afforable solution',
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1606372771_einvoicing3.png',
        link: 'https://cleartax.in/s/e-invoicing-enterprise-software',
        image:
          'https://assets1.cleartax-cdn.com/cleartax/images/1605871021_desktop_fold_plugandplay_enterprise_cleareinvoicing.png',
      },
      {
        id: 'clear-ewaybill',
        label: 'ClearE-WayBill',
        title: 'ClearE-Waybill',
        description: '10x faster waybill solution for large businesses',
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1603967983_ic_ewayb.svg',
        link: 'https://cleartax.in/s/gst-eway-bill-software',
        image:
          'https://assets1.cleartax-cdn.com/cleartax/images/1605871104_desktop_fold_plugandplay_enterprise_clearewaybill.png',
      },
      {
        id: 'clear-gst',
        label: 'ClearGST',
        title: 'ClearGST',
        description: 'G1 to G9 filing, 10x faster reconciliations & reports',
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1603967824_ic_clear_gst.svg',
        link: 'https://cleartax.in/gst',
        image:
          'https://assets1.cleartax-cdn.com/cleartax/images/1605871267_desktop_fold_plugandplay_enterprise_cleargst.png',
      },
      {
        id: 'clear-max-itc',
        label: 'ClearMaxITC',
        title: 'ClearMax ITC',
        description: 'End-to-end solution to maximize ITC for businesses',
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1623152598_taxsavings.png',
        link: 'http://cleartax.in/s/max-itc',
        image:
          'https://assets1.cleartax-cdn.com/cleartax/images/1623153736_maxitc1.png',
      },
    ],
  },
  {
    id: 'tax-expert',
    title: 'Tax Expert',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1605873968_taxexpert.svg',
    image:
      'https://assets1.cleartax-cdn.com/cleartax/images/1605869731_desktop_fold_plugandplay_sme_cleargst.png',
    products: [
      {
        id: 'clear-gst-expert',
        label: 'ClearGST',
        title: 'ClearGST',
        description: 'Comprehensive platform for core GST compliance',
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1603967824_ic_clear_gst.svg',
        link: 'https://cleartax.in/gst',
        image:
          'https://assets1.cleartax-cdn.com/cleartax/images/1605869731_desktop_fold_plugandplay_sme_cleargst.png',
      },
      {
        id: 'clear-tds',
        label: 'ClearTDS',
        title: 'ClearTDS',
        description: 'Go-to platform for effortless TDS returns',
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1606218204_cleartds.svg',
        link: 'https://cleartax.in/tds',
        image:
          'https://assets1.cleartax-cdn.com/cleartax/images/1605870820_desktop_fold_plugandplay_taxexperts_cleartds.png',
      },
      {
        id: 'clear-tax-cloud',
        label: 'ClearTaxCloud',
        title: 'ClearTaxCloud',
        description: 'Seamless ITR filing platform for accountants',
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1603968183_ic_taxcloud.svg',
        link: 'https://taxcloudindia.com/',
        image:
          'https://assets1.cleartax-cdn.com/cleartax/images/1605870742_desktop_fold_plugandplay_taxexperts_cleartaxcloud.png',
      },
      {
        id: 'clear-pro-app',
        label: 'ClearProApp',
        title: 'ClearPro App',
        description: 'Track filing status from your phone in one click',
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1614344289_clearproapp.svg',
        link: 'https://cleartax.in/s/clearpro',
        image:
          'https://assets1.cleartax-cdn.com/cleartax/images/1613564438_mobilemock.png',
      },
    ],
  },
  {
    id: 'smes',
    title: 'SMEs',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1605874025_sme.svg',
    image:
      'https://assets1.cleartax-cdn.com/cleartax/images/1605869731_desktop_fold_plugandplay_sme_cleargst.png',
    products: [
      {
        id: 'clear-gst-sme',
        label: 'ClearGST',
        title: 'ClearGST',
        description: 'From G1 to G9, 3x faster and 2-7% tax savings',
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1603967824_ic_clear_gst.svg',
        link: 'https://cleartax.in/gst',
        image:
          'https://assets1.cleartax-cdn.com/cleartax/images/1605869731_desktop_fold_plugandplay_sme_cleargst.png',
      },
      {
        id: 'clear-one',
        label: 'ClearOne',
        title: 'ClearOne',
        description: 'Billing, Payment Collection & Inventory Software',
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1618557796_clearone.svg',
        link: 'https://cleartax.in/clearone/',
        image:
          'https://assets1.cleartax-cdn.com/cleartax/images/1618559003_c1hero1.png',
      },
    ],
  },
];
